import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import history from '../../../../../history/history';
import {
  ColumnHeader,
  EmptyMessage,
  ActivityTable,
  DisplayValue,
  AlignCenter
} from '../styles';
import Popup from '../../MakeAContribution/Components/ContributionType/Components/Popup/Popup';
import { cancelContribution,replaceWithWholeData } from './../actions';
import moment from 'moment';
import { getPrimaryAccount } from '../../../../../utils/sessionUtil';
import Preloader from '../../../../../CommonComponents/Preloader/Preloader';
import { initiateTracking, recordError } from '../../../../../utils/commonUtil';
import {formatShares, formatSharesWithSixDecimal} from '../../../../../utils/commonUtil';
import PrintTable from '../../../../../CommonComponents/PrintTable/PrintTable';
import infoIcon from '../../../../../assets/icons/shape.svg';
import { Tooltip } from "antd";
import { ActionItems, ActionTitle } from "../../../../Investments/Pages/ViewInvestmentExchangeActivity/Component/ExchangeSelect/style";
import tableIcon from '../../../../../assets/icons/table-action-button.png';
import { MenuContentWrapper } from '../../../../../CommonComponents/commonStyles';
import { contributionActivityTableState } from "../selectors";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";

let currentTransactionId = -1;

export class ContributionActivityTable extends Component {
  constructor(props) {
    super(props);
    this.renderAmount = this.renderAmount.bind(this);
    this.renderNumberOfShares = this.renderNumberOfShares.bind(this);
    this.state = { 
      show: false,
    };
  }

  ViewContribution(id, row) {
    try {
      history.push({
        pathname: '/contributions/activity/view',
        state: { transactionId: id, status: row.status, giftId: row.giftId }
      });
    } catch (error) {
      recordError(error);
    }
  }

  renderAmount(text, data) {
    if (text !== '--') {
      return <DisplayValue className="alignRight contributionAmount">{data.status === 'Reversed' ? '('+text+')' : text}</DisplayValue>;
    } else {
      return <DisplayValue className="alignRight contributionAmount">&mdash;</DisplayValue>;
    }
  }

  renderNumberOfShares(text, record) {
    if (text !== '--') {
      return <DisplayValue className="alignRight contributionShares">{text === 'All Shares' ? text : (record.type === "Special Asset" ? formatSharesWithSixDecimal(text) : formatShares(text)) } </DisplayValue>
    } else {
      return <DisplayValue className="alignRight contributionShares">&mdash;</DisplayValue>;
    }
  }

  closeModal = () => {
    this.setState({
      show: false
    });
  };

  handleExitClick = () => {
    this.setState({
      show: !this.state.show
    });
    history.push('/my-account');
  };

  cancelContribution = () => {
    const data = {
      metaData: {
        method: 'POST',
        page: 'contributionActivity',
        url: {
          contributionActivity: `/donor-portal/api/contribution/${
            getPrimaryAccount().userId
          }/cancelContributionbyOrderId`
        },
        data: {
          orderId: currentTransactionId.orderId
            ? currentTransactionId.orderId
            : 0,
          giftId: currentTransactionId.giftId
        }
      }
    };
    initiateTracking('cancelTable','Contribution Activity', currentTransactionId.status ,'Cancel');
    this.props.cancelContrib(data);
    this.setState({ show: false });
  };

  cancelClick = id => {
    currentTransactionId = id;
    this.setState({ show: true });
  };

  dataSorted = (a, b, direction) => {
    if (a === '--') {
      a = 'a';
    }
    if (b === '--') {
      b = 'b';
    }
    if (a > b) {
      return -1;
    }
    if (a < b) {
      return 1;
    }
    return 0;
  };

  amountSort = (a, b) => {
    if (a === '--') {
      a = '0';
    }
    if(a === 'All Shares') {
      // This is required for sorting
      a = Number.MAX_VALUE.toString();
    }
    if(b === 'All Shares'){
      // This is required for sorting
      b = Number.MAX_VALUE.toString();
    }
    if (b === '--') {
      b = '0';
    }
    let sort = 0;
    a = a.replace('$', '').replace(/,/g, '');
    b = b.replace('$', '').replace(/,/g, '');

    if (Math.round(a * 10000) > Math.round(b * 10000)) {
      sort = -1;
    }
    if (Math.round(a * 10000) < Math.round(b * 10000)) {
      sort = 1;
    }
    return sort;
  };

  sensitiveSort = (a, b) => {
    a = a.toLowerCase();
    b = b.toLowerCase();
    if (a === '--') {
      a = 'a';
    }
    if (b === 'b') {
      b = 'b';
    }
    let sort = 0;
    if (a > b) {
      sort = -1;
    }
    if (a < b) {
      sort = 1;
    }
    return sort;
  };

  dateSorted = (a, b) => {
    if (a === '--' && b === '--') {
      return -1;
    }
    if(a === '--' && b !== "--"){
      return 1;
    }
    if(a !== '--' && b === "--"){
      return -1;
    }
    if (moment(a, 'MM/DD/YYYY') > moment(b, 'MM/DD/YYYY')) {
      return -1;
    }
    if (moment(a, 'MM/DD/YYYY') <= moment(b, 'MM/DD/YYYY')) {
      return 1;
    }
    return 0;
  };

  renderData = (a) => {
    if (a === '--') {
      return <div>&mdash;</div>;
    } else {
      return <div>{a}</div>;
    }
  };

  renderContributionStatus = (text, row) => {
    let status = row.status;
    return (
      <div>
        {row.reversed === false ?
          <MenuContentWrapper>
            <ActionItems id="anrView" onClick={() => this.ViewContribution(text, row)}>
              View
            </ActionItems>
          </MenuContentWrapper>
          : ''
        }
        {
          getPrimaryAccount().role.access !== 'Read Only' &&
          (status.toLowerCase() === 'entered' || status.toLowerCase() === 'pending review' || status.toLowerCase() === 'assets needed') &&
          row.reversed === false &&
          <MenuContentWrapper>
            <ActionItems id="anrCancelTransaction" className="cancelTitle" onClick={() => this.cancelClick(row)}>
              Cancel Transaction
            </ActionItems>
          </MenuContentWrapper>
        }
      </div>
    )
  }

  renderReceivedDate = (a, record) => {
    if (a === '--') {
      return <div>&mdash;</div>;
    } else {
      return record.type === "Special Asset" && record.status === "Entered" ? <div>&mdash;</div> : a;
    }
  }

  render() {
    const columns = [
      {
        title: () => <AlignCenter columnWidth="66px" className="alignCenter columnFirst">Action{"   "}        
          <Tooltip placement="right" title={<p>Click to see more actions for transactions</p>}>
            <span className="infotooltip">
              <img src={infoIcon} alt="tooltip"/>
            </span>
          </Tooltip>
        </AlignCenter>,
        dataIndex: 'txnId',
        key: 'txnId',
        render: (text, row) => {
          return (
            row.reversed === false ? (
                <ActionTitle>
                  <Tooltip overlayClassName={`${!row.reversed ? 'exchangeTooltip cancelTransaction' : 'exchangeTooltip'}`} placement="bottom" title={this.renderContributionStatus(text, row)}>
                    <img src={tableIcon} alt="table" />
                  </Tooltip>
              </ActionTitle>
            ) : (
              <ActionTitle>
                <img className="hamburger-disabled" src={tableIcon} alt="hamburger"/>
              </ActionTitle>
            )
          )
        },
        width: 96
      },
      {
        title: <ColumnHeader className="contributionEnteredDate">Entered<br/>Date</ColumnHeader>,
        dataIndex: 'enteredDate',
        key: 'enteredDate',
        render: this.renderData,        
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => this.dateSorted(a.enteredDate, b.enteredDate)
      },
      {
        title: <ColumnHeader>Description</ColumnHeader>,
        className: 'break-all',
        dataIndex: 'description',
        key: 'description',
        render: (text) =>{
          return <div>
            {this.renderData(text)}
          </div>
        },        
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => this.sensitiveSort(a.description, b.description)
      },
      {
        title: <ColumnHeader className='contributionAmount'>Amount</ColumnHeader>,        
        className: 'break-all',
        dataIndex: 'amount',
        key: 'amount',
        render: (text, row) => this.renderAmount(text, row),        
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => this.amountSort(a.amount, b.amount)
      },
      {
        title: <ColumnHeader className="contributionShares">Number of shares</ColumnHeader>,
        render: (text, record) => this.renderNumberOfShares(text, record),
        dataIndex: 'noOfShares',
        key: 'noOfShares',
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => this.amountSort(a.noOfShares, b.noOfShares),
      },
      {
        title: <ColumnHeader>Received<br/>Date</ColumnHeader>,
        dataIndex: 'receivedDate',
        key: 'receivedDate',
        render: this.renderReceivedDate,        
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => this.dateSorted(a.receivedDate, b.receivedDate)
      },      
      {
        title: <ColumnHeader className="contributionActivitySettledDate">Settled<br/>Date</ColumnHeader>,
        dataIndex: 'settledDate',
        key: 'settledDate',
        render: this.renderData,        
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => this.dateSorted(a.settledDate, b.settledDate)
      },
      {
        title: <ColumnHeader>Status</ColumnHeader>,
        dataIndex: 'status',
        key: 'status',
        render: this.renderData,        
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => this.sensitiveSort(a.status, b.status)
      }
    ];
    const resetPopupContent = this.props.drupalData ? 
    {
      heading: this.props.drupalData.field_header,
      line1: this.props.drupalData.field_description,
      line2: '',
      continue: this.props.drupalData.field_alert_button1_text,
      cancel: this.props.drupalData.field_alert_button2_text,
      type: 'exit'
    } : {
      heading: 'Cancel Contribution',
      line1:
        'Are you sure you want to cancel this contribution? Selecting continue will cancel the Contribution.',
      line2: 'Do you want to continue?',
      continue: 'Continue',
      cancel: 'No, take me back',
      type: 'exit'
    };
    const printColumns = [
      {
        title: <ColumnHeader>Entered Date*</ColumnHeader>,
        dataIndex: 'enteredDate',
        key: 'enteredDate',
        width: '5%',
        sortDirections: ['ascend', 'descend'],
        sorter: true
      },
      {
        title: <ColumnHeader>Description</ColumnHeader>,
        dataIndex: 'description',
        key: 'description',
        width: '10%',
        sortDirections: ['ascend', 'descend'],
        sorter: true
      },
      {
        title: <ColumnHeader>Amount</ColumnHeader>,
        render: this.renderAmount,
        dataIndex: 'amount',
        key: 'amount',
        width: '10%',
        sortDirections: ['ascend', 'descend'],
        sorter: true
      },
      {
        title: <ColumnHeader>Number of shares</ColumnHeader>,
        render: (text, record) => this.renderNumberOfShares(text, record),
        dataIndex: 'noOfShares',
        key: 'noOfShares',
        width: '12%',
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => a.noOfShares - b.noOfShares
      },
      {
        title: <ColumnHeader>Received Date</ColumnHeader>,
        dataIndex: 'receivedDate',
        key: 'receivedDate',
        width: '15%',
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => a.receivedDate - b.receivedDate
      },     
      {
        title: <ColumnHeader>Settled Date</ColumnHeader>,
        dataIndex: 'settledDate',
        key: 'settledDate',
        width: '10%',
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => a.settledDate - b.settledDate
      },
      {
        title: <ColumnHeader>Status</ColumnHeader>,
        dataIndex: 'status',
        key: 'status',
        width: '10%',
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => a.status - b.status
      }
    ];

    let contrData = [];
    if (this.props.contributionData) {
            contrData = this.props.contributionData;
    } else {
      return <Preloader />;
    }
    return (
      <div>
        {this.state.show === true ? (
          <Popup
          data-test="popup"
            width='500px'
            mwidth='88%'
            mheight='60%'
            content={resetPopupContent}
            closeModal={this.closeModal}
            handleExitClick={() => this.cancelContribution()}
          />
        ) : null}
        {this.props.print ? (
          <PrintTable 
            data-test='print-table'
            columns={printColumns}
            dataSource={contrData}
          />
        ) : (
          <>          
            <ActivityTable
              data-test='activity-table'
              className="overflowForIE contributionActivityTable"
              locale={{
                emptyText: (
                  <div class='ant-empty ant-empty-normal'>
                    <EmptyMessage class='ant-empty-description'>
                    {this.props.loadMore || this.props.timeFrameData.dates!==null? "You currently have no contribution activity based on the filters applied.":"You currently have no contribution activity."}
                    </EmptyMessage>
                  </div>
                )
              }}
              length={contrData?.length}
              pagination={false}
              columns={columns}
              dataSource={contrData}
              onChange={(pagination, filters, sorter, extra) => this.props.exportData(extra, sorter)}
              scroll={{ y: 500 }}
               footer={this.props.loadMore ? () => <div className="contribution__activity__footer__wrapper"> <GeneralButton 
               onClick ={()=>{             
                 this.setState({loadedMore:true})
                 this.props.replaceWithWholeData(this.props.contributionWholeData)
                  }
               } 
                text = "Load More" 
                styling="loadMore"
                />  </div>:null }
            />

          </>
        )}
      </div>
    );
  }
}

ContributionActivityTable.propTypes = {
  contributionData: PropTypes.array,
  drupalData: PropTypes.array,
  cancelContrib: PropTypes.func
}

const mapStateToProps = state => ({
  ...contributionActivityTableState(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  cancelContrib: data => dispatch(cancelContribution(data)),
  replaceWithWholeData: data => dispatch(replaceWithWholeData(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContributionActivityTable);